import type { FactorDirection, FactorName } from "../types/factor.ts";
import { FACTOR_NAMES } from "../types/factor.ts";
import { FACTOR_REGISTRY } from "../config/factor-registry.ts";

export const WINSORIZATION_CONFIG = {
  lowerPercentile: 0.05,
  upperPercentile: 0.95,
} as const;

export const PEER_GROUP_CONFIG = {
  marketCapControl: true,
  marketCapBuckets: 3,
  minPeerGroupSize: 5,
  minIndustrySizeForMarketCapControl: 15,
} as const;

export const FACTOR_DIRECTIONS = Object.fromEntries(
  FACTOR_NAMES.map((factorName) => [factorName, FACTOR_REGISTRY[factorName].direction]),
) as Record<FactorName, FactorDirection>;